import $ from "jquery";
import Page from "../pages/Page";


class Component {
    public domSelector: string;
    public domElement!: HTMLElement;
    public isOptional: boolean;

    constructor(domSelector: string, isOptional: boolean = false) {
        this.domSelector = domSelector;
        this.isOptional = isOptional;
        this.init();
    }

    private init() : void {
        let elements = document.querySelectorAll(this.domSelector);
        if (elements.length === 0) {
            if (this.isOptional) {
                console.log(`Optional component: No elements found for selector ${this.domSelector}`);
            } else {
                console.error(`No elements found for selector ${this.domSelector}`);
            }
            return;
        }
        if (elements.length > 1) {
            console.warn(`Multiple elements found for selector ${this.domSelector}`);
        }
        this.domElement = elements[0] as HTMLElement;
    }
    
    public activate() : Promise<void> {
        return Promise.resolve();
    }
    
    public destroy() : void {}
    
    public show() : Component {
        let el = this.domElement;
        if (el) {
            el.classList.remove("invisible");
            el.classList.remove("hidden");
            // Rimuove il valore inline, in modo che il browser usi il valore di default o quello determinato dal CSS
            el.style.display = "";

            // Se l'elemento è ancora nascosto, imposta un valore di default (in questo caso "block")
            if (window.getComputedStyle(el).display === "none") {
                el.style.display = "block";
            }
        }
        return this;
    }
    
    public hide() : Component {
        
        let el = this.domElement;
        if (el) {
            el.classList.add("hidden");
            // Imposta il valore inline a "none"
            el.style.display = "none";
        }
        return this;
    
    }
    
    public html(html: string) : Component {
        let el = this.domElement;
        if (el) {
            el.innerHTML = html;
        }
        return this;
    }
    
    protected get currentPage() : Page {
        return Page.current
    }
}

export default Component;   